import React from "react";
import { Link } from "react-router-dom";
import { Reveal, Overline } from "../components/Reveal";
import { ArrowUpRight, ShieldCheck, BadgeCheck, FileCheck, HardHat, Sparkles, Clock } from "lucide-react";

const COVERED = [
  { icon: BadgeCheck, t: "1-Year Workmanship Warranty", d: "Every remodel is covered by a written one-year warranty on our workmanship. If something isn't right, we make it right — no hassle." },
  { icon: ShieldCheck, t: "Licensed & Insured", d: "We are fully licensed and insured in Virginia, protecting you and your property throughout the entire project." },
  { icon: FileCheck, t: "Written Agreements", d: "Clear, detailed contracts and transparent pricing. No surprises, no hidden fees — just honest work." },
  { icon: HardHat, t: "Safety First", d: "Our crews follow strict safety standards and keep your home clean and secure from start to finish." },
  { icon: Sparkles, t: "Premium Materials", d: "We use trusted, high-quality materials and installation methods designed to stand the test of time." },
  { icon: Clock, t: "On-Time Delivery", d: "We respect your schedule with realistic timelines and consistent communication at every milestone." },
];

export default function GuaranteesPage() {
  return (
    <div>
      <section className="relative pt-36 md:pt-44 pb-20 overflow-hidden">
        <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 0%, rgba(212,175,55,0.12), transparent 55%)" }} />
        <div className="relative max-w-[1400px] mx-auto px-6 md:px-10 text-center">
          <Reveal>
            <Overline className="justify-center">Our Promise</Overline>
            <h1 className="mt-6 font-serif font-light text-5xl md:text-7xl leading-[0.95]">Backed by a <em className="gold-gradient-text">1-year warranty.</em></h1>
            <p className="mt-8 max-w-2xl mx-auto text-white/60 font-body text-lg leading-relaxed">
              Peace of mind is part of every project. GI Remodeling stands behind its work with a written 1-year workmanship warranty and a commitment to doing things the right way.
            </p>
          </Reveal>

          <Reveal delay={0.15}>
            <div className="mt-14 inline-flex flex-col items-center border border-gold/40 bg-[#0a0a0a] px-14 py-10">
              <p className="font-serif text-7xl md:text-8xl gold-gradient-text leading-none">1</p>
              <p className="mt-2 text-sm uppercase tracking-[0.3em] text-white/70">Year Workmanship Warranty</p>
            </div>
          </Reveal>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 md:px-10 pb-28">
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-px bg-white/10 border border-white/10">
          {COVERED.map((c, i) => {
            const Icon = c.icon;
            return (
              <Reveal key={i} delay={(i % 3) * 0.08}>
                <div className="bg-[#0a0a0a] p-8 md:p-10 h-full hover:bg-[#0f0f0f] transition-colors duration-500">
                  <Icon size={30} className="text-gold" strokeWidth={1.4} />
                  <h3 className="mt-6 font-serif text-2xl">{c.t}</h3>
                  <p className="mt-3 text-white/55 font-body text-sm leading-relaxed">{c.d}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>

      <section className="border-t border-white/10 bg-[#080808] py-24 text-center">
        <Reveal>
          <h2 className="font-serif font-light text-4xl md:text-5xl px-6">Remodel with total confidence.</h2>
          <Link data-testid="guarantees-cta" to="/contact" className="mt-8 inline-flex items-center gap-3 bg-gold text-black text-sm font-semibold uppercase tracking-widest px-8 py-4 hover:bg-white transition-colors duration-300">
            Request a Free Quote <ArrowUpRight size={18} />
          </Link>
        </Reveal>
      </section>
    </div>
  );
}
